import { SkeletonLoader } from './SkeletonLoader';

import { cn } from '@/utils/styles';
import type { StyleClasses } from '@/utils/types';

type SkeletonEditorLoaderStyleClasses = StyleClasses<'root' | 'line'>;

export type SkeletonEditorLoaderProps = {
  className?: string;
  classes?: SkeletonEditorLoaderStyleClasses;
  lineCount?: number;
};

// Predefined widths for varying line lengths (as percentages)
const LINE_WIDTHS = [95, 85, 75, 90, 60, 80, 100, 65, 88, 70, 92, 55, 78, 83, 95, 68, 85, 72];

export const SkeletonEditorLoader = ({ className, classes, lineCount = 20 }: SkeletonEditorLoaderProps) => {
  return (
    <div className={cn('flex flex-col gap-1', className, classes?.root)}>
      {/* eslint-disable react/no-array-index-key */}
      {Array.from({ length: lineCount }).map((_, index) => {
        // Cycle through predefined widths for more realistic appearance
        const widthPercent = LINE_WIDTHS[index % LINE_WIDTHS.length];
        return (
          <SkeletonLoader
            key={index}
            className={cn('h-4 rounded-sm', classes?.line)}
            style={{ width: `${widthPercent}%` }}
          />
        );
      })}
      {/* eslint-enable react/no-array-index-key */}
    </div>
  );
};

SkeletonEditorLoader.displayName = 'SkeletonEditorLoader';
